import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStylesOutlined = makeStyles<Theme>((theme) => ({
	inputAutoCompleteOutlined: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.primary.main,
		},
		"& .MuiFormHelperText-root": {
			background: "none !important",
		},
		"& .MuiFormHelperText-root.Mui-disabled": {
			color: theme.palette.error.main,
		},
		"& .MuiAutocomplete-popupIndicator:not(.Mui-disabled)": {
			zIndex: 1,

			"& .MuiSvgIcon-root": {
				background: "white",
			},
		},
		"& .Mui-disabled": {
			backgroundColor: "#d7d7d7",
			color: "rgba(0, 0, 0, 0.38)",
		},
		"& .MuiAutocomplete-option.Mui-focused": {
			color: `${theme.palette.getContrastText(theme.palette.action.focus ?? theme.palette.primary.main)} !important`,
		},
		'& .MuiAutocomplete-option[aria-selected="true"]': {
			color: `${theme.palette.getContrastText(theme.palette.primary.main)} !important`,
		},
		'& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
			color: `${theme.palette.getContrastText(theme.palette.primary.main)} !important`,
		},
		"& .MuiInputBase-root": {
			height: "40px",
			background: "white",
			border: `1px solid ${theme.palette.grey[400]}`,
			borderRadius: "10px",
			overflow: "hidden",
			textAlign: "center",
			padding: "0 !important",

			"&.MuiInput-underline:before": {
				borderBottom: "none",
			},
			"&.MuiInput-underline:hover:before": {
				borderBottom: "none !important",
			},
			"&.Mui-disabled": {
				backgroundColor: "#d7d7d7",
				color: "rgba(0, 0, 0, 0.38)",
			},
		},
		"& .MuiInputBase-input": {
			font: "inherit",
			fontSize: "0.875rem",
			letterSpacing: "normal",
			height: "100%",
			color: "#000",

			"&.Mui-disabled": {
				color: "rgba(0, 0, 0, 0.38)",
			},
			"&::placeholder": {
				color: "#000",
			},
		},
		"& .MuiAutocomplete-endAdornment": {
			right: "7px !important",
		},
	},
}));
